export class ServerError extends Error {
	statusCode = 500;

	constructor() {
		super('Something went wrong');
	}
}
